import { useEffect, useState } from "react";

/**
 * Hook to debounce error states to prevent flashing during initial app load
 * Only shows errors after a delay, and resets immediately when error state becomes false
 */
export const useDebouncedError = (isError: boolean, isLoading: boolean, delay = 500) => {
  const [debouncedError, setDebouncedError] = useState(false);

  useEffect(() => {
    if (!isError) {
      // Reset immediately when error state becomes false
      setDebouncedError(false);
      return;
    }

    if (isLoading) {
      // Don't show errors while still loading
      setDebouncedError(false);
      return;
    }

    // Debounce showing the error state
    const timeout = setTimeout(() => {
      setDebouncedError(true);
    }, delay);

    return () => clearTimeout(timeout);
  }, [isError, isLoading, delay]);

  return debouncedError;
};
